<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Medicamento já prescrito e dentro do prazo de uso"
    >
        <rkm-form
            ref="RkmForm"
        >

        <template v-if="item">

                <rkm-row>

                    <rkm-col cols="11">

                        <rkm-row>
                            <rkm-col>
                                <strong>Medicamento</strong><br/>{{item.material}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Via de administração</strong><br/>{{item.materialViaAdministracao}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Posologia</strong><br/>{{item.posologia}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Dose única</strong><br/>{{item.isDoseUnica}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Uso contínuo</strong><br/>{{item.isUsoContinuo}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Início do tratamento</strong><br/>{{item.inicio}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Duração</strong><br/>{{item.duracao}} {{ item.duracaoMedidaTempo }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Conclusão do tratamento</strong><br/>{{item.dataConclusao}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Recomendações</strong><br/>
                                <div v-html="formatDescricao(item.recomendacoes)"></div>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-button
                            color="info"
                            small
                            title="Imprimir"
                            @click="print(item.receitaTipoId, false)"
                            :disabled="!item.receitaTipoId"
                        >
                            <rkm-icon icon="print" />
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                Continuar a prescrição
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import frequenciaDose from '@/enums/ambulatorio/frequenciaDose'
import medidaTempo from '@/enums/cadastro/medidaTempo'
import receitaTipo from '@/enums/cadastro/medicamento/tipoReceita'
import tipoGrupo from '@/enums/cadastro/grupo/tipoGrupo'

// Mixins.
import {object, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        enums: {
            frequenciaDose,
            medidaTempo,
            receitaTipo,
            tipoGrupo,
        },
        fields: [
            {key: 'codigo_material', searchable: true},
            {key: 'descricao', searchable: true},
        ],
        item: null,
        model: {
            isManual: null,
            receitaTipoId: receitaTipo.COMUM,
            descricao: null,
            justificativa: null,
            material: null,
            dose: null,
            isDoseUnica: false,
            frequenciaDose: null,
            intervalo: null,
            intervaloMedidaTempoId: medidaTempo.DIAS,
            frequenciaVezes: null,
            turnoId: null,
            isUsoContinuo: false,
            isImprimirSeparado: false,
            isRemoverImpressao: false,
            inicio: null,
            duracao: null,
            duracaoMedidaTempoId: null,
            recomendacoes: null,
            unidadeMedidaId: null,
            unidadeMedida: null,
        },
        others: {moment},
        editorQuill: null,
        editorQuillDescricao: null,
        editorQuillJustificativa: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            this.$refs.RkmModal.show()
        },
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
        print(tipoReceita, isManual) {

            const material = this.clone(this.item)

            material.material = {
                descricao: material.material,
                apresentacao: "Unidade",
                id: material.id,
                quantidade: 1,
                receita_tipo: "Comum",
                receitaTipoId: material.receitaTipoId,
                via_administracao: material.materialViaAdministracao,
            }

            const item = {
                multiple: true,
                emAtendimento: true,
                isDuplicated: true,
                atendimentoId: this.data.additionals.atendimentoId,
                medicamentos: [material]
            };

            let request = null

            if (isManual) {
                if (tipoReceita == this.enums.receitaTipo.ESPECIAL) {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaEspecial(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
                } else {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaComum(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
                }
            } else if (tipoReceita == this.enums.receitaTipo.ESPECIAL) {
                request = this.repositories.pdf.receitaMedicaEspecial(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.receitaTipo.ESPECIAL_AMARELA) {
                request = this.repositories.pdf.receitaMedicaEspecialAmarela(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
            } else if (tipoReceita == this.enums.receitaTipo.ESPECIAL_AZUL) {
                request = this.repositories.pdf.receitaMedicaEspecialAzul(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
            } else {
                request = this.repositories.pdf.receitaMedicaComum(this.data.additionals.atendimentoId, this.camelObjectKeysToSnakeRecursive(item))
            }

            this.setLoading()

            request
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSave() {

            this.$refs.RkmModal.hide()

            this.$emit('save')
        }
    },
    mixins: [object, file, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>